module.exports = __webpack_public_path__ + "img/inplat.d3664f74.png";